import React from 'react';
import { cn } from '../../lib/utils';
import { useTheme } from '../../contexts/ThemeContext';
import { SECTION_HEADER_STYLES, headerVariantForItem } from '../../config/menuSidebarUtils';

const SECTION_SUBTITLES = {
  QMS: 'Quality · Compliance',
  Operations: 'Tasks · Planning',
  IT: 'Support · Ticketing',
  Admin: 'System · Config',
};

const SidebarSectionHeader = ({ item, collapsed }) => {
  const { theme } = useTheme();
  if (collapsed) return null;

  const label = (item.name || '').replace(/── | ──/g, '').trim();
  const variant = headerVariantForItem(item);
  const accent = cn(
    'rounded-r-md border-l-[4px] px-3 py-2',
    'shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]',
    ...(SECTION_HEADER_STYLES[variant] || SECTION_HEADER_STYLES.default)
  );
  const subtitle = SECTION_SUBTITLES[label];

  return (
    <div
      className="px-2 pt-4 pb-1.5 first:pt-2"
      role="presentation"
      aria-label={`${label} section`}
    >
      <div className={accent}>
        <div className="text-[11px] font-bold uppercase tracking-[0.14em] leading-tight">
          {label}
        </div>
        {subtitle && (
          <div
            className={cn(
              'mt-0.5 text-[10px] font-normal normal-case tracking-normal opacity-80',
              theme.text.secondary
            )}
          >
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default SidebarSectionHeader;
